import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import logo from '../logo2.png';
import SidebarNav from "./SidebarNav";

const AddBankAccount = () => {
    const [accountNumber, setAccountNumber] = useState('');
    const [bankName, setBankName] = useState('');
    const [balance, setBalance] = useState('');
    const [message, setMessage] = useState('');

    const handleAddAccount = async (e) => {
        e.preventDefault();

        // 显示确认框，并显示用户输入的信息
        const confirmation = window.confirm(
            `请确认该信息:\n\n银行账号: ${accountNumber}\n银行: ${bankName}\n初始资金: ${balance}`
        );

        // 如果用户选择 "Cancel"，则不执行后续代码
        if (!confirmation) {
            return;
        }

        // 如果用户确认，继续添加银行账户的逻辑
        const { error } = await supabase.from('bank_accounts').insert([
            {
                account_number: accountNumber,
                bank_name: bankName,
                balance: parseFloat(balance),
            },
        ]);

        if (error) {
            setMessage('Error adding bank account');
        } else {
            setMessage('Bank account added successfully');
            setAccountNumber('');
            setBankName('');
            setBalance('');
        }
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <SidebarNav />

            {/* Main Content */}
            <div className="lg:pl-64">
                <div className="max-w-4xl mx-auto px-4 py-8">
                    {/* Header */}
                    <div className="mb-8">
                        <div className="flex items-center justify-between">
                            <img
                                src={logo}
                                alt="Kindbridge Investments"
                                className="h-12 w-auto"
                            />
                        </div>
                        <h1 className="text-2xl font-semibold text-gray-900">
                            添加银行账号
                        </h1>
                        <p className="mt-2 text-sm text-gray-600">
                            请填写以下表单添加新的银行账号
                        </p>
                    </div>

                    {/* Message Display - Placed before form card for more immediate visibility */}
                    {message && (
                        <div className={`mb-6 p-4 rounded-md ${
                            message.includes('成功')
                                ? 'bg-green-50 text-green-800'
                                : 'bg-red-50 text-red-800'
                        }`}>
                            <p className="text-sm">{message}</p>
                        </div>
                    )}

                    {/* Form Card */}
                    <div className="bg-white shadow-sm rounded-lg border border-gray-200">
                        <form onSubmit={handleAddAccount} className="p-6 space-y-6">
                            {/* Bank Account Number */}
                            <div>
                                <label htmlFor="account-number" className="block text-sm font-medium text-gray-700">
                                    银行账号<span className="text-red-500 ml-1">*</span>
                                </label>
                                <input
                                    id="account-number"
                                    type="text"
                                    placeholder="请输入银行账号"
                                    value={accountNumber}
                                    onChange={(e) => setAccountNumber(e.target.value)}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    required
                                />
                            </div>

                            {/* Bank Name */}
                            <div>
                                <label htmlFor="bank-name" className="block text-sm font-medium text-gray-700">
                                    银行名称<span className="text-red-500 ml-1">*</span>
                                </label>
                                <input
                                    id="bank-name"
                                    type="text"
                                    placeholder="请输入银行名称"
                                    value={bankName}
                                    onChange={(e) => setBankName(e.target.value)}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    required
                                />
                            </div>

                            {/* Initial Balance */}
                            <div>
                                <label htmlFor="initial-balance" className="block text-sm font-medium text-gray-700">
                                    初始余额<span className="text-red-500 ml-1">*</span>
                                </label>
                                <div className="mt-1 relative rounded-md shadow-sm">
                                    <input
                                        id="initial-balance"
                                        type="number"
                                        placeholder="0.00"
                                        value={balance}
                                        onChange={(e) => setBalance(e.target.value)}
                                        className="block w-full rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                        min="0"
                                        step="0.01"
                                        required
                                    />
                                </div>
                            </div>

                            {/* Submit Button */}
                            <div className="pt-4">
                                <button
                                    type="submit"
                                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                                >
                                    添加账号
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddBankAccount;
